import * as events from './productFilter/productFilterEvents';
import {
  filterProductsArray, filterProductsDom, getActiveFiltersFromUrl, getFilterItems,
  hideFiltersWithNoResults, renderActiveFiltersFromState, resetState, toggleMobileMenu,
  updateUrlParamsFromState, resetFiltersCheckbox, gaResetFilterState
} from './productFilter/productFilterHelpers';
import { preloader } from './helpers/preloader';
import { handleProductSelectorResultPage, handleProductSelectorStartOver } from './analytics/listeners/productSelectorEvents'

/**
 * Filter product list by various criteria. It is possible to combine filters.
 * Functionalities and appearance differ on small and large screens.
 * https://scadev.atlassian.net/wiki/spaces/TCWProductTeam/pages/3498246146/Product+Filter+-+Hidden+Functionality
 */
window.HMSProductFilter = class HMSProductFilter {
  constructor() {
    this.isOpen = false;
    this.filters = new Map();
    this.allProducts = [];
    this.state = {
      activeFilters: [],
      products: new Set()
    };
    this.tempState = {};
    this.init();
  }

  /**
   * Add event listeners
   */
  addEvents() {
    $('.js-product-filter-toggle').on('click', () =>
      toggleMobileMenu(this));
    $('.js-product-filter-item-toggle').on('click', event => events
      .onFilterGroupToggle($(event.currentTarget).parents('.js-product-filter-item'), this));
    $('.js-product-filter-btn').on('change', event => events
      .onFilterToggle(event, this));
    $('.js-product-filter-reset-all').on('click', () => {
      events.onFilterResetAll(this);
      resetFiltersCheckbox();
      gaResetFilterState();
    });
    $('.js-product-filter-apply').on('click', () => events
      .onFilterApply(this));
    $('body').on('click', '.js-product-filter-deactivate-filter', event => events
      .onFilterDeactivate(event, this));
    $(window).on('resize', () => events
      .onWindowResize(this));
    $('.product-selector-email-wrapper').on('click', '.js-popup-close', () => {
      $('.product-selector-email-wrapper').fadeOut(200);
      handleProductSelectorResultPage();
    });
  }

  /**
   * The filters from the dom
   */
  indexFilters() {
    $.each($('.js-product-filter-item'), (index, filter) => {
      const $filter = $(filter);
      const filterGroupName = $filter.data('filter-group').toLowerCase();
      const items = getFilterItems($filter, filterGroupName);

      this.filters.set(filterGroupName, { items });
    });
  }

  /**
   * Loops through the DOM, gets product ids
   */
  indexProducts() {
    $('.js-product-filter-list-item').each((index, product) => {
      this.allProducts.push(product.id);
      this.state.products.add(product.id);
    });
  }

  /**
   * Sets filters by reading params from page url.
   * Filters products
   */
  filterFromUrlParams() {
    this.state.activeFilters = getActiveFiltersFromUrl(this);
    this.state.products = filterProductsArray(this.state, this);
    resetState(this.tempState, this.state);
    renderActiveFiltersFromState(this.state);
    filterProductsDom(this.state);
    hideFiltersWithNoResults(this.state, this);
  }

  /**
   * Initializes a links that returns to the product selector page.
   * @param {string} linkSelector - The jQuery selector for the link element.
   * @param {string} flagName - The name of the flag to set in sessionStorage on click.
   * @param {boolean} showWrapper - Whether to show a wrapper element if the link is initialized.
   */
  initializeProductSelectorLinks(linkSelector, flagName, showWrapper = false) {
    const productSelectorSource = sessionStorage.getItem('productSelectorSource');
    const $productSelectorLink = $(linkSelector);

    if (productSelectorSource === 'true') {
      const productSelectorUrl = sessionStorage.getItem('productSelectorPageUrl');

      $productSelectorLink.attr('href', productSelectorUrl);

      if (showWrapper) {
        $('.product-selector-email-wrapper').css('display', 'flex');
        $('.product-selector-link-wrapper').css('display', 'flex');
      }
    }

    $(document).off('click', linkSelector).on('click', linkSelector, event => {
      event.preventDefault();
      sessionStorage.setItem(flagName, 'true');

      if (linkSelector === '.js-product-selector-link') {
        handleProductSelectorStartOver();
      }

      sessionStorage.removeItem('productSelectorStepNumber');
      window.location.href = $productSelectorLink.attr('href');
    });
  }

  initializeProductSelectorLink() {
    this.initializeProductSelectorLinks('.js-product-selector-link', 'returningToProductSelector', true);
  }

  initializeProductSelectorLastStepLink() {
    this.initializeProductSelectorLinks('.js-product-selector-last-step-link', 'returningToProductSelectorLastStep');

    const productSelectorSource = sessionStorage.getItem('productSelectorSource');

    if (productSelectorSource === 'true') {
      sessionStorage.removeItem('productSelectorSource');
      sessionStorage.removeItem('productSelectorPageUrl');
    }
  }

  /**
   * Inits the Product filter.
   * Adds event listeners
   * Indexes the filters from the dom.
   * Indexes products from the dom.
   */
  init() {
    this.addEvents();
    this.indexFilters();
    this.indexProducts();
    resetState(this.tempState, this.state);
    this.filterFromUrlParams();
    updateUrlParamsFromState(this);
    this.initializeProductSelectorLink();
    this.initializeProductSelectorLastStepLink();
    preloader($('.body'), false);
  }
};
